// App.js
import { ToastContainer } from "react-toastify";
import {RouterComponent} from "components/RouterComponent";
import { useEffect } from "react";
import { useAuthStore } from "store/useAuthStore";

const App = () => {
  const initializeAuthListener = useAuthStore(
    (state) => state.initializeAuthListener
  );

  useEffect(() => {
    const cleanupFn = initializeAuthListener();
    return cleanupFn;
  }, []);

  return (
    <>
      <ToastContainer />
      <main>
        <RouterComponent />
      </main>
    </>
  );
};

export default App;
